// extracted by mini-css-extract-plugin
export default {"wrapper":"servicecategories_wrapper__uYBYF","cardWrapper":"servicecategories_cardWrapper__eRCTN","card":"servicecategories_card__G3+cH","cover":"servicecategories_cover__abiCK"};